module.exports = "img/flags/LI.b568bc0.png";